<template>
  <v-container fluid class="pa-0">
    <iframe
      class="privacy-pdf"
      src="https://intrare-empresa.s3.us-east-2.amazonaws.com/terms_conditions/Aviso_de_Privacidad_Intrare_2026.pdf"
      title="Aviso de privacidad Intrare 2026"
    ></iframe>
  </v-container>
</template>

<script>
export default {
  name: 'notice_privacy'
}
</script>

<style scoped>
.privacy-pdf {
  display: block;
  width: 100%;
  height: 80vh;
  min-height: 600px;
  border: 0;
}
</style>
